import update from 'immutability-helper'
import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  GET_FACEBOOK_DEBUG_TOKENS,
  GET_FACEBOOK_DEBUG_TOKENS_SUCCESS,
  GET_FACEBOOK_DEBUG_TOKENS_FAILURE,
  CLEAR_GET_FACEBOOK_DEBUG_TOKENS,
  GET_FACEBOOK_PAGES_LEAD_GEN_FORMS,
  GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_SUCCESS,
  GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_FAILURE,
  CLEAR_GET_FACEBOOK_PAGES_LEAD_GEN_FORMS,
  GET_FACEBOOK_PAGES,
  GET_FACEBOOK_PAGES_SUCCESS,
  GET_FACEBOOK_PAGES_FAILURE,
  CLEAR_FACEBOOK_PAGES,
  GET_ACCESSIBLE_SOCIAL_PAGES,
  GET_ACCESSIBLE_SOCIAL_PAGES_SUCCESS,
  GET_ACCESSIBLE_SOCIAL_PAGES_FAILURE,
  ADD_ACCESSIBLE_SOCIAL_PAGES,
  ADD_ACCESSIBLE_SOCIAL_PAGES_SUCCESS,
  ADD_ACCESSIBLE_SOCIAL_PAGES_FAILURE,
  CLEAR_ADD_ACCESSIBLE_SOCIAL_PAGES,
  DELETE_ACCESSIBLE_SOCIAL_PAGES,
  DELETE_ACCESSIBLE_SOCIAL_PAGES_SUCCESS,
  DELETE_ACCESSIBLE_SOCIAL_PAGES_FAILURE,
  CLEAR_DELETE_ACCESSIBLE_SOCIAL_PAGES,
  GET_INSTAGRAM_ACCOUNTS,
  GET_INSTAGRAM_ACCOUNTS_SUCCESS,
  GET_INSTAGRAM_ACCOUNTS_FAILURE,
  CLEAR_INSTAGRAM_ACCOUNTS,
  GET_FACEBOOK_PAGE_ACCESS_TOKEN,
  GET_FACEBOOK_PAGE_ACCESS_TOKEN_SUCCESS,
  GET_FACEBOOK_PAGE_ACCESS_TOKEN_FAILURE,
  CLEAR_FACEBOOK_PAGE_ACCESS_TOKEN,
  CREATE_FACEBOOK_PAGE_ACCESS_REQUEST,
  CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_SUCCESS,
  CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_FAILURE,
  CLEAR_CREATE_FACEBOOK_PAGE_ACCESS_REQUEST,
  CLEAR_ACCESSIBLE_SOCIAL_PAGES,
  GET_BACKED_INSTAGRAM_ACCOUNTS,
  GET_BACKED_INSTAGRAM_ACCOUNTS_SUCCESS,
  GET_BACKED_INSTAGRAM_ACCOUNTS_FAILURE,
  CLEAR_BACKED_INSTAGRAM_ACCOUNTS
} from '../actions/socialAccounts'
import {
  INITIAL_CREATE_REDUCER,
  INITIAL_DELETE_REDUCER,
  INITIAL_GET_RESULTS_REDUCER,
  INITIAL_LOADING_REDUCER
} from '../../constants/reducer'
import { deleteItemById } from '../../helpers/reducerHelpers'

const INITIAL_GET_TOKEN_REDUCER = {
  ...INITIAL_LOADING_REDUCER,
  token: '',
  wasLoaded: false
}

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  facebookDebugTokens: INITIAL_GET_RESULTS_REDUCER,
  facebookPages: INITIAL_GET_RESULTS_REDUCER,
  accessibleSocialPages: INITIAL_GET_RESULTS_REDUCER,
  addAccessibleSocialPage: INITIAL_CREATE_REDUCER,
  deleteAccessibleSocialPage: INITIAL_DELETE_REDUCER,
  facebookPageAccessTokens: {},
  createFacebookPageAccessRequest: INITIAL_CREATE_REDUCER,
  instagramAccounts: {},
  backedInstagramAccounts: {},
  facebookPagesLeadGenForms: INITIAL_GET_RESULTS_REDUCER
}

export default function socialAccounts(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS

    // facebook pages
    case GET_FACEBOOK_PAGES:
      return update(state, {
        facebookPages: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_FACEBOOK_PAGES_SUCCESS:
      return update(state, {
        facebookPages: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.pagesData
          }
        }
      })
    case GET_FACEBOOK_PAGES_FAILURE:
      return update(state, {
        facebookPages: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_FACEBOOK_PAGES:
      return update(state, {
        facebookPages: {
          $set: initialState.facebookPages
        }
      })

    // accessible facebook pages
    case GET_ACCESSIBLE_SOCIAL_PAGES:
      return update(state, {
        accessibleSocialPages: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_ACCESSIBLE_SOCIAL_PAGES_SUCCESS:
      return update(state, {
        accessibleSocialPages: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.pagesData.results
          }
        }
      })
    case GET_ACCESSIBLE_SOCIAL_PAGES_FAILURE:
      return update(state, {
        accessibleSocialPages: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_ACCESSIBLE_SOCIAL_PAGES:
      return update(state, {
        accessibleSocialPages: {
          $set: initialState.accessibleSocialPages
        }
      })
    // POST accessible facebook pages
    case ADD_ACCESSIBLE_SOCIAL_PAGES:
      return update(state, {
        addAccessibleSocialPage: {
          $merge: {
            isLoading: true
          }
        }
      })
    case ADD_ACCESSIBLE_SOCIAL_PAGES_SUCCESS:
      return update(state, {
        addAccessibleSocialPage: {
          $merge: {
            isLoading: false,
            wasCreated: true
          }
        },
        accessibleSocialPages: {
          results: { $unshift: [action.pageData] }
        }
      })
    case ADD_ACCESSIBLE_SOCIAL_PAGES_FAILURE:
      return update(state, {
        addAccessibleSocialPage: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_ADD_ACCESSIBLE_SOCIAL_PAGES:
      return update(state, {
        addAccessibleSocialPage: {
          $set: initialState.addAccessibleSocialPage
        }
      })

    // DELETE accessible facebook pages
    case DELETE_ACCESSIBLE_SOCIAL_PAGES:
      return update(state, {
        deleteAccessibleSocialPage: {
          $merge: {
            isLoading: true,
            id: action.id
          }
        }
      })
    case DELETE_ACCESSIBLE_SOCIAL_PAGES_SUCCESS:
      return update(state, {
        deleteAccessibleSocialPage: {
          $merge: {
            isLoading: false,
            wasCreated: true
          }
        },
        accessibleSocialPages: {
          results: { $apply: items => deleteItemById(items, action.id) }
        }
      })
    case DELETE_ACCESSIBLE_SOCIAL_PAGES_FAILURE:
      return update(state, {
        deleteAccessibleSocialPage: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_DELETE_ACCESSIBLE_SOCIAL_PAGES:
      return update(state, {
        deleteAccessibleSocialPage: {
          $set: initialState.deleteAccessibleSocialPage
        }
      })

    // facebook page access token
    case GET_FACEBOOK_PAGE_ACCESS_TOKEN:
      return update(state, {
        facebookPageAccessTokens: {
          $merge: {
            [action.facebookPageId]: {
              ...INITIAL_GET_TOKEN_REDUCER,
              isLoading: true
            }
          }
        }
      })
    case GET_FACEBOOK_PAGE_ACCESS_TOKEN_SUCCESS:
      return update(state, {
        facebookPageAccessTokens: {
          $merge: {
            [action.facebookPageId]: {
              isLoading: false,
              wasLoaded: true,
              token: action.accessToken
            }
          }
        }
      })
    case GET_FACEBOOK_PAGE_ACCESS_TOKEN_FAILURE:
      return update(state, {
        facebookPageAccessTokens: {
          $merge: {
            [action.facebookPageId]: {
              isLoading: false,
              error: action.error
            }
          }
        }
      })
    case CLEAR_FACEBOOK_PAGE_ACCESS_TOKEN:
      return update(state, {
        facebookPageAccessTokens: {
          $set: initialState.facebookPageAccessTokens
        }
      })

    // Create facebook page access request
    case CREATE_FACEBOOK_PAGE_ACCESS_REQUEST:
      return update(state, {
        createFacebookPageAccessRequest: { $merge: { isLoading: true } }
      })
    case CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_SUCCESS:
      return update(state, {
        createFacebookPageAccessRequest: {
          $merge: {
            isLoading: false,
            wasCreated: true
          }
        }
      })
    case CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_FAILURE:
      return update(state, {
        createFacebookPageAccessRequest: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_CREATE_FACEBOOK_PAGE_ACCESS_REQUEST:
      return update(state, {
        createFacebookPageAccessRequest: { $set: initialState.createFacebookPageAccessRequest }
      })

    // instagram accounts
    case GET_INSTAGRAM_ACCOUNTS:
      return update(state, {
        instagramAccounts: {
          $merge: {
            [action.facebookPageId]: {
              ...INITIAL_GET_RESULTS_REDUCER,
              isLoading: true
            }
          }
        }
      })
    case GET_INSTAGRAM_ACCOUNTS_SUCCESS:
      return update(state, {
        instagramAccounts: {
          $merge: {
            [action.facebookPageId]: {
              isLoading: false,
              wasLoaded: true,
              results: action.accountsData
            }
          }
        }
      })
    case GET_INSTAGRAM_ACCOUNTS_FAILURE:
      return update(state, {
        instagramAccounts: {
          $merge: {
            [action.facebookPageId]: {
              isLoading: false,
              error: action.error
            }
          }
        }
      })
    case CLEAR_INSTAGRAM_ACCOUNTS:
      return update(state, {
        instagramAccounts: {
          $set: initialState.instagramAccounts
        }
      })
    // backed instagram accounts
    case GET_BACKED_INSTAGRAM_ACCOUNTS:
      return update(state, {
        backedInstagramAccounts: {
          $merge: {
            [action.facebookPageId]: {
              ...INITIAL_GET_RESULTS_REDUCER,
              isLoading: true
            }
          }
        }
      })
    case GET_BACKED_INSTAGRAM_ACCOUNTS_SUCCESS:
      return update(state, {
        backedInstagramAccounts: {
          $merge: {
            [action.facebookPageId]: {
              isLoading: false,
              wasLoaded: true,
              results: action.accountsData
            }
          }
        }
      })
    case GET_BACKED_INSTAGRAM_ACCOUNTS_FAILURE:
      return update(state, {
        backedInstagramAccounts: {
          $merge: {
            [action.facebookPageId]: {
              isLoading: false,
              error: action.error
            }
          }
        }
      })
    case CLEAR_BACKED_INSTAGRAM_ACCOUNTS:
      return update(state, {
        backedInstagramAccounts: {
          $set: initialState.backedInstagramAccounts
        }
      })

    // Get facebook pages lead gen forms
    case GET_FACEBOOK_PAGES_LEAD_GEN_FORMS:
      return update(state, {
        facebookPagesLeadGenForms: { $merge: { isLoading: true } }
      })
    case GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_SUCCESS:
      return update(state, {
        facebookPagesLeadGenForms: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data.data
          }
        }
      })
    case GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_FAILURE:
      return update(state, {
        facebookPagesLeadGenForms: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_FACEBOOK_PAGES_LEAD_GEN_FORMS:
      return update(state, {
        facebookPagesLeadGenForms: { $set: initialState.facebookPagesLeadGenForms }
      })

    // Get facebook debug tokens
    case GET_FACEBOOK_DEBUG_TOKENS:
      return update(state, {
        facebookDebugTokens: { $merge: { isLoading: true } }
      })
    case GET_FACEBOOK_DEBUG_TOKENS_SUCCESS:
      return update(state, {
        facebookDebugTokens: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_FACEBOOK_DEBUG_TOKENS_FAILURE:
      return update(state, {
        facebookDebugTokens: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_FACEBOOK_DEBUG_TOKENS:
      return update(state, {
        facebookDebugTokens: { $set: initialState.facebookDebugTokens }
      })

    default:
      return state
  }
}
